import { Routes, Route, useNavigate } from "react-router-dom"
import NotFoundError from "../../components/Alerts/NotFoundError"
import { useSelector } from "react-redux"
import { selectAuth } from "../../store/selectors/auth.selector"
// import { useEffect } from "react"
import ReadAcrossPage from "./page/ReadAcrossPage"
import IndividualReadAcrossPage from "./page/IndividualReadAcrossPage"

export default function ReadAcrossRoutes() {
    // const authUser = useSelector(selectAuth);
    // const navigate = useNavigate();

    // useEffect(() => {
    //     if (!authUser) {
    //         navigate('/401');
    //     }
    // }, [authUser]);

    return (
        <Routes>
            <Route index element={<ReadAcrossPage />} />
            <Route path=':id' element={<IndividualReadAcrossPage />} />
            <Route path='404' element={<NotFoundError />} />
        </Routes>
    )
}